import { push } from "connected-react-router";
import * as fb from 'firebase/app';

import {
    authStateChanged as authStateChangedAction,
    logIn as logInAction,
} from '../actions';
import { ThunkAction } from "../types";

export function authStateChanged(user: fb.User | null): ThunkAction {
    return async dispatch => {
        dispatch(authStateChangedAction(user));

        if (!user) {
            await dispatch<any>(push('/login'));
            return;
        }
    };
}

export function logIn(username: string, password: string): ThunkAction {
    return async (dispatch, _, {firebase}) => {
        try {
            dispatch(logInAction.request());

            await firebase.auth().signInWithEmailAndPassword(username, password);

            dispatch(logInAction.success());

            await dispatch<any>(push('/'));
        } catch (error) {
            dispatch(logInAction.failure(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/thunks/authThunks.ts